export default __webpack_public_path__ + "static/media/workouttimes_5@2x.8af83c48.jpg";